import React from 'react';
import { connect } from 'react-redux';
// tslint:disable-next-line:import-name
import ReactPlatformHeader from '@cimpress-technology/react-platform-header';
import IconCogDouble from '@cimpress-technology/react-streamline-icons/lib/IconCogDouble';
import { logOut } from '../../store/actions/auth';
import { Link } from 'react-router-dom';
import { Profile } from '../../models/auth';
import { useHistory } from 'react-router';
import { useFeature } from '../../store/hooks/useFeature';
import { Features } from '../../models/features';
import { StoreState } from '../../store/state';

interface Props {
  userProfile: Profile;
  userIsLoggedIn: boolean;
  onLogout: Function;
  selectedLocationName: string;
}

// tslint:disable-next-line:variable-name
const Header = ({
  userProfile,
  userIsLoggedIn,
  onLogout,
  selectedLocationName,
}: Props) => {
  const selectedLocationText = `• ${selectedLocationName}`;

  const showSettings = useFeature(Features.SHOW_SETTINGS);
  const showWorkflows = useFeature(Features.WORKFLOWS);

  const history = useHistory();

  const appLinks = [
    {
      id: 'home',
      type: 'default',
      content: <Link to="/">Home</Link>,
    },
    {
      id: 'locations',
      type: 'default',
      content: <Link to="/locations">Locations</Link>,
    },
    {
      id: 'sortation',
      type: 'default',
      content: <Link to="/sortation">Shipments</Link>,
    },
    {
      id: 'manifests',
      type: 'default',
      content: <Link to="/manifests">Manifests</Link>,
    },
  ];

  if (showWorkflows.value) {
    appLinks.push({
      id: 'workflows',
      type: 'default',
      content: <Link to="/workflows">
        <IconCogDouble color="var(--primary)"/>
      </Link>,
    });
  }

  return (
    <ReactPlatformHeader
      responsive
      appTitle={`Shipping Operations ${selectedLocationText}`}
      profile={userProfile}
      onLogInClicked={() => { }}
      onLogOutClicked={onLogout}
      isLoggedIn={userIsLoggedIn}
      appLinks={appLinks}
      onSettingsClicked={showSettings.value ? () => history.push('/settings') : undefined}
    />
  );
};

const mapStateToProps = (state: StoreState) => ({
  userProfile: state.user.profile,
  userIsLoggedIn: state.user.isLoggedIn,
  selectedLocationName: state.location.name,
});

const mapDispatchToProps = {
  onLogout: logOut.request,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);
